export function attachLinkedInScript(partnerId) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    window._linkedin_partner_id = partnerId;
    window._linkedin_data_partner_ids =
        window._linkedin_data_partner_ids || [];
    window._linkedin_data_partner_ids.push(partnerId);

    (function(l) {
        if (!l) {
            window.lintrk = function(a, b) {
                window.lintrk.q.push([ a, b ]);
            };
            window.lintrk.q = [];
        }
    })(window.lintrk);

    if (document.querySelector('script[data-linkedin-insight]')) {
        return;
    }

    const firstScript = document.getElementsByTagName('script')[0];
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://snap.licdn.com/li.lms-analytics/insight.min.js';
    script.setAttribute('data-linkedin-insight', 'true');

    firstScript.parentNode.insertBefore(script, firstScript);
}

export function attachGTMScript(containerId) {
    (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l !== 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', containerId);
}
/**
 * Checks if the env knows about AwsWafIntegration (means the script is here)
 * If the lib is here, check if a valid token exists
 * If there is no valid token, get one.
 * @return {Promise<void>}
 */

export async function checkAwsWafProtection() {
    if (typeof AwsWafIntegration !== 'undefined' && !AwsWafIntegration.hasToken()) {
        // nothing to do, we're just getting a token if possible
        await AwsWafIntegration.getToken();
    }
};
